<template>
  <div class="preview-bar" :class="classObject">
    <div class="preview-bar__inner">
      <p class="preview-bar__title">
        プレビュー表示中<br /><span class="preview-bar__limit">
          【有効期限】{{ expirationDate }}まで
        </span>
      </p>
      <div class="preview-bar__qrcode-area">
        <button
          class="preview-bar__qrcode-btn"
          type="button"
          @click="handleClick"
        >
          <img :src="btnImageSrc" alt="スマートフォンでプレビューする" />
        </button>
        <div class="preview-bar__balloon">
          <p class="preview-bar__balloon-txt">
            スマートフォンでの確認は<br />QRコードを読み取ると<br />スムーズに<br />ご確認いただけます。
          </p>
          <div class="preview-bar__qrcode">
            <qr-code />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import btnImageSrc from '@/assets/images/preview-btn.png'
import QrCode from '@/components/QrCode.vue'

const props = defineProps({
  /**
   * 有効期限
   */
    expire: {
    type: String,
    required: true,
  },
})

const hiddenQrCode = ref(true)

const classObject = computed(() => {
  const ua = navigator.userAgent.toLowerCase()
  const mobile = /i(phone|pod)/.test(ua) || /android(.+)?mobile/.test(ua)

  return {
    hiddenQrCode: hiddenQrCode.value,
    mobile,
  }
})

const expirationDate = computed(() => {
  const unixtime = props.expire
  const formattedDate = unixtimeToDate(unixtime)
  return formattedDate
})

// const btnImageSrc = async () => {
//   return '@/assets/images/preview-btn.png'
// }

const unixtimeToDate = (unixtime) => {
  const date = new Date(Number(unixtime) * 1000)
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minutes = ('0' + date.getMinutes()).slice(-2)
  const weekChars = ['日', '月', '火', '水', '木', '金', '土']
  const weekday = weekChars[date.getDay()]
  const result = `${month}/${day} (${weekday}) ${hour}:${minutes}`
  return result
}

const handleClick = () => {
  hiddenQrCode.value = !hiddenQrCode.value
}
</script>

<style lang="scss" scoped>
$easeOutQuint: cubic-bezier(0.23, 1, 0.32, 1);

.preview-bar {
  position: relative;
  z-index: 10;
  padding: 1rem 0;
  background-color: $color-gray-text;

  .preview-bar__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 50rem;
    margin: 0 auto;
    flex-direction: column;
    gap: 1rem;
    @media screen and (min-width: $tablet-breakpoint) {
      flex-direction: row;
    }
  }

  .preview-bar__title {
    color: #fff;
    font-size: 1.4rem;
    line-height: 1.6875;
    word-break: break-all;
    @media screen and (min-width: $tablet-breakpoint) {
      font-size: 1.6rem;
    }
  }

  .preview-bar__limit {
    font-size: 1rem;
    @media screen and (min-width: $tablet-breakpoint) {
      font-size: 1.2rem;
    }
  }

  .preview-bar__qrcode-area {
    position: relative;
  }

  .preview-bar__qrcode-btn {
    flex-shrink: 0;
    width: 19.2rem;
    padding: 0;
    border: 0;
    background-color: transparent;
    line-height: 1;
    cursor: pointer;

    > img {
      width: 100%;
      vertical-align: middle;
    }
  }

  .preview-bar__balloon {
    visibility: visible;
    position: absolute;
    top: 3.6rem;
    right: 0;
    left: 0;
    width: 15rem;
    margin: 0 auto;
    padding: 2.4rem 0 1.6rem;
    transform: none;
    transition: opacity 0.3s $easeOutQuint, visibility 0s 0s $easeOutQuint,
      transform 0.4s $easeOutQuint;
    border: 0.1rem solid #ccc;
    border-radius: 0.2rem;
    opacity: 1;
    background-color: #fff;
    @media screen and (min-width: $tablet-breakpoint) {
      width: 19rem;
    }

    &::before {
      content: '';
      position: absolute;
      top: -0.52rem;
      right: 0;
      left: 0;
      width: 0;
      height: 0;
      margin: 0 auto;
      border-right: 0.35rem solid transparent;
      border-bottom: 0.5rem solid #ccc;
      border-left: 0.35rem solid transparent;
    }

    &::after {
      content: '';
      position: absolute;
      top: -0.35rem;
      right: 0;
      left: 0;
      width: 0;
      height: 0;
      margin: 0 auto;
      border-right: 0.35rem solid transparent;
      border-bottom: 0.5rem solid #fff;
      border-left: 0.35rem solid transparent;
    }
  }

  .preview-bar__balloon-txt {
    color: #c81432;
    font-size: 1rem;
    line-height: 1.6875;
    text-align: center;
    @media screen and (min-width: $tablet-breakpoint) {
      font-size: 1.2rem;
    }
  }

  .preview-bar__qrcode {
    width: 11rem;
    height: 11rem;
    margin: 0 auto;
  }

  &.mobile {
    .preview-bar__inner {
      padding: 0 2rem;
    }

    .preview-bar__qrcode-area {
      display: none;
    }
  }

  &.hiddenQrCode {
    .preview-bar__balloon {
      visibility: hidden;
      transform: translateY(-5%);
      transition: opacity 0.34s $easeOutQuint, visibility 0s 0.34s $easeOutQuint,
        transform 0.34s $easeOutQuint;
      opacity: 0;
    }
  }
}
</style>
